export const getYouTubeId = (url?: string | null): string | false => {
  if (!url) {
    return false
  }
  // The following regular expression covers these patterns:
  // 1. https://youtu.be/<id>
  // 2. https://www.youtube.com/watch?v=<id>
  // 3. https://www.youtube.com/v/<id>
  // 4. https://www.youtube.com/embed/<id>
  // 5. https://www.youtube.com/u/<user>/<id>
  // 5. https://www.youtube.com/shorts/<id>
  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|shorts\/|watch\?v=|&v=)([^#&?]*).*/
  const match = url.match(regExp)

  // If a match is found and the extracted potential ID has the correct length of 11 (typical YouTube video ID length),
  // return the ID. Otherwise, return false.
  return match && match[2].length === 11 ? match[2] : false
}

export const getVimeoId = (url?: string | null) => {
  if (!url) {
    return false
  }

  var regex = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i
  var match = url.match(regex)

  return match && match[1] ? match[1] : false
}

export const getCloudflareStreamId = (url?: string | null) => {
  if (!url) {
    return false
  }

  // Match Cloudflare Stream URLs in the format:
  // https://customer-<CODE>.cloudflarestream.com/<VIDEO_UID>/iframe
  // or https://customer-<CODE>.cloudflarestream.com/<VIDEO_UID>
  const regex =
    /(?:customer-[a-zA-Z0-9]+\.cloudflarestream\.com\/)([a-zA-Z0-9]+)(?:\/iframe)?/i
  const match = url.match(regex)

  return match && match[1] ? match[1] : false
}

export const getCloudflareStreamThumbnail = (
  url?: string | null,
  videoId?: string,
) => {
  if (!url && !videoId) {
    return null
  }

  // If we have a URL, extract customer code and video ID from it
  if (url) {
    const customerMatch = url.match(
      /customer-([a-zA-Z0-9]+)\.cloudflarestream\.com/,
    )
    const extractedVideoId = getCloudflareStreamId(url)

    if (customerMatch && customerMatch[1] && extractedVideoId) {
      const customerCode = customerMatch[1]
      return `https://customer-${customerCode}.cloudflarestream.com/${extractedVideoId}/thumbnails/thumbnail.jpg?time=&height=600`
    }
  }

  return null
}
